<template>
    <div name="ai-medication" class="ai-medication" v-if="step === 0" style="padding-bottom: calc(100vw * 120 / 375);">
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/1.png" @click="goHistory"/>
        
        <img v-if="hospital === 0" class="image" src="../../assets/showcase/xi/detail/common/medication/2_1.png" />
        <img v-else class="image" src="../../assets/showcase/xi/detail/common/medication/2_2.png" />
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/medication/3.png" />
            <div class="button1" @click="goDetail">
            
            </div>
            <div class="button2" @click="goQuestionnaire">
        
            </div>
            <div class="button3" > 
        
            </div>
            <!-- <div class="button4">

            </div> -->
        </div>
        
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/4.png" style="margin-top: -6px;"/>
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/5.png" @click="() => step = 1" />
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/6.png" />
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/7.png" @click="() => step = 2"/>
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/8.png" @click="() => step = 3" />
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/9.png"  />
    </div>
    <div class="ai-medication" v-else-if="step === 1" style="padding-bottom: calc(100vw * 120 / 375);">
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/d1.png" @click="() => step = 0">
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/d2.png" />
    </div>
    <div class="ai-medication" v-else-if="step === 2" style="padding-bottom: calc(100vw * 120 / 375);">
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/m1_1.png" @click="() => step = 0"/>
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/m1_2.png" />
    </div>
    <div class="ai-medication" v-else-if="step === 3" style="padding-bottom: calc(100vw * 120 / 375);">
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/m2_1.png" @click="() => step = 0"/>
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/m2_2.png" />
    </div>
</template>

<script>
export default {
    name: 'aiMedication',
    props: ['hospital'],
    data: function()
    {
        return {
            step: 0
        }
    },
    methods: {
        goDetail: function()
        {
            this.$emit('goDetailTab');
        },
        goQuestionnaire: function()
        {
            this.$emit('goQuestionnaireTab');
        },
        goDelivery: function()
        {
            this.$emit('goDeliveryTab');
        },
        goHistory: function()
        {
            this.$emit('goHistory')
        }
    }
}
</script>

<style scoped>
    .ai-medication {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .image {
        width: 100%;
    }
        .wrapper {
        position: relative;
        width: 100%;
    }
 .button1 {
        position: absolute;
        width: 20%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 18%;
        aspect-ratio: 2/1.3;
        top: 0;
        left: 20%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 15%;
        aspect-ratio: 2/1.6;
        top: 0;
        left: 38%;
        z-index: 1;
    }
     .button4 {
        position: absolute;
        width: 21%;
        aspect-ratio: 2/1.1;
        top: 0;
        left: 53%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/AiMedication.vue